var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackingApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2C12.318 2 2 12.318 2 25C2 37.683 12.318 48 25 48C37.683 48 48 37.683 48 25C48 12.318 37.683 2 25 2ZM35.827 16.562L24.316 33.525L15.319 25.176C14.914 24.801 14.89 24.168 15.266 23.763C15.641 23.357 16.275 23.335 16.679 23.71L23.969 30.474L34.172 15.438C34.483 14.981 35.105 14.863 35.561 15.172C36.019 15.482 36.138 16.104 35.827 16.562Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingApprove);
export default __webpack_public_path__ + "static/media/trackingApprove.9cd46c730a259e8edffd41cafcd3067c.svg";
export { ForwardRef as ReactComponent };